import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer'
import moment from 'moment'

import { feeValue, formatAmount } from '../../lib/numbers'

export default function PledgeReceipt({ business, pledge, fileName }) {
  const { t } = useTranslation()

  return (
    <Document title={fileName}>
      <Page size="LETTER" style={styles.pdfPage}>
        <View style={styles.block}>
          <Image style={styles.img} src="/images/meta_logo.png" />
        </View>
        <View style={styles.blockLarge}>
          <Text style={styles.title}>{t('pdf.pledgeReceipt.title')}</Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.civicRushProgram.label')}
          </Text>
          <Text style={[styles.textline, styles.text]}>
            {t('pdf.pledgeReceipt.civicRushProgram.text')}
          </Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.transactionDate')}
          </Text>
          <Text style={[styles.textline, styles.text]}>
            {moment(pledge?.created_at).format(t('config.date_format'))}
          </Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.sponsor')}
          </Text>
          <Text style={[styles.textline, styles.text]}>{business?.name}</Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.event')}
          </Text>
          <Text style={[styles.textline, styles.text]}>
            {pledge?.event?.title}
          </Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.eventDate')}
          </Text>
          <Text style={[styles.textline, styles.text]}>
            {moment(pledge?.event?.event_start_date).format(
              t('config.date_format'),
            )}
          </Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.paymentMethod')}
          </Text>
          <Text
            style={[styles.textline, styles.text]}
          >{`****${business.bank_account.bank_account_number_last4}`}</Text>
        </View>
        <View style={styles.columnBlock}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.sponsorAmount')}
          </Text>
          <Text style={[styles.textline, styles.text]}>{`${formatAmount(
            pledge?.amount,
          )} CIV`}</Text>
        </View>
        <View style={[styles.columnBlock, styles.blockLarge]}>
          <Text style={[styles.textline, styles.label]}>
            {t('pdf.pledgeReceipt.serviceFee')}
          </Text>
          <Text style={[styles.textline, styles.text]}>
            {formatAmount(
              feeValue(pledge?.amount, pledge?.meta_admin_fee),
              true,
            )}
          </Text>
        </View>
        {/* <View style={styles.block}>
          <Text style={styles.disclaimer}>
            {t('pdf.pledgeReceipt.disclaimer')}
          </Text>
        </View> */}
      </Page>
    </Document>
  )
}

const styles = StyleSheet.create({
  pdfPage: {
    padding: '10px 50px',
    border: 'black',
    fontFamily: 'Roboto',
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
  },
  img: {
    width: '150px',
    height: '150px',
    alignSelf: 'center',
  },
  blockLarge: {
    paddingBottom: '50px',
  },
  block: {
    paddingBottom: '20px',
  },
  columnBlock: {
    flexDirection: 'row',
    paddingBottom: '20px',
  },
  textline: {
    fontSize: 18,
    textAlign: 'justify',
  },
  label: {
    width: '200px',
  },
  text: {
    width: '350px',
  },
  disclaimer: {
    fontSize: 10,
  },
})
